import { getConciliationAccountDisplayNumber } from '../../utils/conciliationAccountDisplay'
import clsx from 'clsx'
import { Text } from '../ui'
import { useEffect, useState } from 'react'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { formatCurrency, formatDate } from '../../utils/formatter'
import { bankIcons } from '../views/dashboard/Administracion/bancos/data'
import imgDefaultBank from '../../../assets/iconos/iconCasa.png'

const TablaAdmVinculacion = ({ onCheckboxChange, rows, dataLinkage, dataModal,modalStatus,setSelectedIds,selectedIds,setInitialSelectedIds,unselectedIds,
  setUnselectedIds, onCurrentData,onSort, order,setForceShowAll,setUserInteracted,selectedCheckboxes,setSelectedCheckboxes, montoMode }) => {
  const [isInitialSelectionDone, setIsInitialSelectionDone] = useState(false)
  const [processedRows, setProcessedRows] = useState([])

  const handleCheckboxToggle = (id) => {
  const wasChecked = !!selectedCheckboxes[id];
  const updatedSelection = {
    ...selectedCheckboxes,
    [id]: !wasChecked,
  };
  setSelectedCheckboxes(updatedSelection);

  const newSelectedIds = Object.keys(updatedSelection)
    .filter((key) => updatedSelection[key])
    .map((key) => Number(key));

  setSelectedIds(newSelectedIds);

  const selectedData = rows.filter(row => newSelectedIds.includes(row.id));
  onCurrentData(selectedData)
  if (wasChecked) {
    if (['COBRADO', 'PAGADO'].includes(modalStatus)) {
      setForceShowAll(true);
    }
    setUnselectedIds((prev = []) => [...new Set([...prev, id])]);
    } else {
      setUnselectedIds((prev = []) => prev.filter((unId) => unId !== id));
    }
  };

  const styles = {
    wrapper: 'overflow-x-auto rounded-3xl shadow-sm',
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight',
    thead: 'sticky top-0 z-10 bg-gray-50',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-400 font-medium',
  }

  const showAbono =
    montoMode === 'abono'
      ? true
      : montoMode === 'cargo'
        ? false
        : rows.some(item => item.montoAbono !== 0)
  const showCargo =
    montoMode === 'cargo'
      ? true
      : montoMode === 'abono'
        ? false
        : rows.some(item => item.montoCargo !== 0)

  const orderableCols = [
    { col: '', field: null },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Cuenta Corriente', field: 'cuentaCorriente' },
    { col: 'Descripción', field: 'descripción' },
    showAbono && { col: 'Abono', field: 'montoAbono' },
    showCargo && { col: 'Cargo', field: 'montoCargo' },
    { col: 'Disponible', field: null },
    /*{ col: 'Status', field: 'status' },*/
    { col: 'Acciones', field: 'acciones' },
  ].filter(Boolean)

  useEffect(() => {
  if (isInitialSelectionDone || !Array.isArray(rows) || rows.length === 0) return;

  const newSelection = {};

  const isCobradorPagado =
    ['COBRADO', 'PAGADO', 'PARCIALMENTE COBRADO', 'PARCIALMENTE PAGADO'].includes(modalStatus);

  const isDataModalLinkageParcialmenteConciliado =
    (dataModal?.linkage?.status || '').toUpperCase() === 'PARCIALMENTE CONCILIADO';

  const linkageComprobantes = Array.isArray(dataModal?.linkage)
    ? dataModal.linkage.map(item => item.comprobante)
    : [];

  // ---- Aplicar tu lógica de selección normal
  rows.forEach((item) => {
    const itemStatus = (item.status);
    const isPorPagar = ['PENDIENTE', 'PARCIALMENTE'].includes(itemStatus);

    const isSameLinkage =
      item.linkage?.idPrincipal && dataLinkage?.idPrincipal &&
      item.linkage.idPrincipal === dataLinkage.idPrincipal;

    const shouldBeSelected =
      (
        !!dataLinkage && !isPorPagar &&
        (item.seleccionado === true || isSameLinkage)
      )
      ||
      (
        isCobradorPagado &&
        isDataModalLinkageParcialmenteConciliado &&
        itemStatus === 'parcialmente conciliado' &&
        isSameLinkage
      )
      ||
      (
        isCobradorPagado &&
        linkageComprobantes.includes(item.comprobante)
      );

    if (shouldBeSelected) newSelection[item.id] = true;
  });

  // ---- 4) Combinar extraRows con las normales
  const finalRows = [...rows];

  setSelectedCheckboxes(newSelection);
  const selectedIds = Object.keys(newSelection);
  const selectedData = finalRows.filter(row => selectedIds.includes(String(row.id)));

  onCheckboxChange(selectedIds);
  onCurrentData(selectedData);

  // ---- 5) Guardar las filas procesadas
  setProcessedRows(finalRows); // necesitas crear este estado
  setIsInitialSelectionDone(true);
}, [rows, modalStatus, dataModal, dataLinkage]);

  useEffect(() => {
    // Resetear el estado de inicialización cuando cambian datos clave
    setIsInitialSelectionDone(false)
    setSelectedCheckboxes({}) // Opcional, si querés limpiar la selección
  }, [dataLinkage, dataModal?.id])

useEffect(() => {
  if (isInitialSelectionDone) {
    setProcessedRows([ ...rows]);
  }
}, [rows]);

  if ((!rows?.length || rows.length === 0) && (!processedRows?.length || processedRows.length === 0)) {
  return (
    <Text className='grid place-items-center py-12'>
      No existen movimientos para la selección utilizada.
    </Text>
  );
}

    else
    return (
      <div className={styles.wrapper}>
        <div className=' mt-1 font-sans'>
            <table className={styles.table}>
              <thead className={styles.thead}>
                <tr>
                  {orderableCols.map(({ col, field }, i) => (
                    <th
                      className={clsx(
                        styles.th,
                        { 'cursor-pointer': field },
                        i === 0 && styles.mediumCol
                      )}
                      onClick={() => field && onSort({ col, field })}
                      key={i}
                    >
                      {col}
                      {order.col === col && (
                        <KeyboardArrowDownIcon
                          className={clsx('transition-all ml-2 cursor-pointer', {
                            'opacity-40': order.col !== col,
                            'rotate-180': order.direction === 'desc'
                          })}
                        />
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className={styles.tbody}>
                {processedRows?.filter(row => row.nombreCuentaBanco !== "Caja Principal")
                  ?.map((item, i) => {
                  const isChecked = !!selectedCheckboxes[item.id];
                  return (
                    <tr key={item.id} className={styles.tr}>
                      <td className={clsx(styles.td, styles.smallCol, 'text-center')}>
                        <div className="flex items-center justify-center gap-1">
                          <input type="checkbox" className="rounded" checked={isChecked} onChange={() => handleCheckboxToggle(item.id)} />
                          <img src={bankIcons[item.nombreCuentaBanco] || imgDefaultBank} className="h-6 w-auto rounded" />
                        </div>
                      </td>
                      <td className={clsx(styles.td, styles.smallCol)}>
                        <Text className={styles.boldText}>{formatDate(item.fecha)}</Text>
                      </td>
                      <td className={clsx(styles.td, styles.wideCol)}>
                        <Text className={styles.boldText}>{item.nombreCuentaBanco}</Text>
                        <Text className={styles.text}>{getConciliationAccountDisplayNumber(item, item.numeroCuentaBanco)}</Text>
                      </td>
                      <td className={clsx(styles.td, styles.wideCol)}>
                        <Text className={styles.boldText}>{item.descripcion || item.glosa}</Text>
                      </td>
                      {showAbono && (
                        <td className={clsx(styles.td, styles.mediumCol)}>
                          <Text className={styles.boldText}>{formatCurrency(item.montoAbono || item.debe)}</Text>
                        </td>
                      )}
                      {showCargo && (
                        <td className={clsx(styles.td, styles.mediumCol)}>
                          <Text className={styles.boldText}>{formatCurrency(item.montoCargo || item.haber)}</Text>
                        </td>
                      )}
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <Text className={styles.boldText}>{formatCurrency(item.auxiliar)}</Text>
                      </td>

                     <td className={clsx(styles.td, styles.mediumCol)}>
                      <div className='flex h-full items-center justify-center space-x-3'>
                      <div className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'>
                          <button
                            className={clsx(
                              'flex items-center justify-center w-7 h-7 rounded-full shadow-full-xs transition-colors duration-150',
                              {
                                'bg-accent2 text-white hover:bg-accent2/90 cursor-pointer': isChecked,
                                'bg-gray-100 text-gray-300 hover:bg-gray-200 cursor-pointer': !isChecked,
                              }
                            )}
                            onClick={() => handleCheckboxToggle(item.id)}
                          >
                            <DoneAllIcon className="w-4 h-4" />
                          </button>
                          <Text className='mt-2'>
                            {isChecked ? 'Seleccionado' : 'Seleccionar'}
                          </Text>
                        </div>
                      </div>
                    </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
      </div>
    )
}

export default TablaAdmVinculacion
